import { render, staticRenderFns } from "./DeliveryPerPriceRatio.vue?vue&type=template&id=1ef5b8fc&lang=pug&"
import script from "./DeliveryPerPriceRatio.vue?vue&type=script&lang=ts&"
export * from "./DeliveryPerPriceRatio.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryPerPriceRatio.vue?vue&type=style&index=0&id=1ef5b8fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports